class GraphicUsage {
  static updateNumGraphicUsageLabel(currentBtn, graphicUsage) {
    currentBtn.data('graphic-source', graphicUsage);
    const currentRow = currentBtn.parent().parent();

    if (country !== 'AU' && country !== 'NZ') return;

    let source = currentRow.find('.info_graphic_source');

    if (graphicUsage) {
      if (!source.length) {
        source = $('<p>');
        source.addClass('info_graphic_source');

        currentRow.find('.info_contributors').after(source);
      }

      source.html(`Source: ${graphicUsage}`);
    } else {
      source.remove();
    }
  }
}

module.exports = GraphicUsage;
